import { Constants } from "utils";

/**
 * function to return a given date in the correct format
 * @param {Date} date date to be looked up
 * @param {string} locale locale
 * @returns {string | null} the formatted date
 */


export const formattedDate = (date: Date, locale: string = "EN", format: any = Constants.DATE_FORMAT.YEAR_MONTH): string | null => {
  if (!date) return null;
  return date.toLocaleDateString(locale, format);
};

/**
 * function to convert rgb format to hex color format
 * @param {number} r red value 
 * @param {number} g green value 
 * @param {number} b blue value 
 * @return {string} the color in Hex format
 */

export const toHexAsRgb = (r: number, g: number, b: number): string => {
  return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
}

/**
 * function to convert rgb string format to hex color format
 * @param {string} rgb rgb value
 * @return {string} the color in Hex format
 */

export const toHexAsRgbString = (rgb: string): string => {
  return toHexAsRgb(...toRgbAsString(rgb));
}

/**
 * function to convert rgb string format to rgb object
 * @param {string} rgb rgb value
 * @return {[number, number, number]} the rgb object
 */

export const toRgbAsString = (rgb: string): [number, number, number] => {
  const rgbValues = rgb
    .substring(4, rgb.length - 1)
    .split(",")
    .map((value) => parseInt(value.trim(), 10));
  return [rgbValues[0], rgbValues[1], rgbValues[2]];
}

/**
 * function to convert hex string format to rgb object
 * @param {string} hex hex value
 * @return {[number, number, number]} the rgb object
 */

export const toRgbAsHex = (hex: string): [number, number, number] => {
  const bigint = parseInt(hex.replace("#", ""), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return [r, g, b];
};
